/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_NoInputs */

const en_mk_cmp_no = /** @type {(inputs: Mk_Cmp_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No`)
};

const id_mk_cmp_no = /** @type {(inputs: Mk_Cmp_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak`)
};

/**
* | output |
* | --- |
* | "No" |
*
* @param {Mk_Cmp_NoInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_no = /** @type {((inputs?: Mk_Cmp_NoInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_NoInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_no(inputs)
	return en_mk_cmp_no(inputs)
});